import { createContext, useContext } from "react";
import { useStore } from "zustand";
import { useShallow } from "zustand/react/shallow";

import { ShortlistsState, ShortlistsStoreContextType, ShortlistsStoreType } from "./shortlists_store.types";

export const ShortlistsStoreContext = createContext<ShortlistsStoreContextType>(
  {} as ShortlistsStoreContextType
);

export const useShortlistsStore = <U>(selector: (state: ShortlistsStoreType) => U) => {
  const store = useContext(ShortlistsStoreContext);

  return useStore(store, useShallow(selector));
};

export const useShortlistsActions = () => {
  const store = useContext(ShortlistsStoreContext);

  return useStore(store, (state) => state.actions);
};

export const getInitialShortlistsState = (): ShortlistsState => ({
  shortlistsParams: {
    page: 1,
    perPage: 10
  }
});
